<template>
    <mm-select :options="options" 
    v-bind="$attrs" :value="value" v-on="$listeners" />
</template>

<script>
export default {
	data(){
		const options = ['daily','hourly'].map(v => {
			const label = v[0].toUpperCase()+v.slice(1);
			return { value: v, label: label };
		});
		return{
			options,
		}
	},
	props:['value'],
}
</script>

